module.exports = __webpack_public_path__ + "static/media/february-youtube.40470182.jpg";